module.exports = __webpack_public_path__ + "img/IOC-alt.8de8753a.svg";